module.exports = __webpack_public_path__ + "static/img/led_difuso_amarelo_3mm-1.c20ee04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_amarelo_3mm-1.svg
// module id = smak
// module chunks = 0